<template>
  <div class="page-article">
    <app-page-box title="文章发布概况">
      <app-overview-bar>
        <app-overview-bar-item label="智能发布量" tip="系统AI智能发布文章数量" :value="stats.aiPublishArticleCount"></app-overview-bar-item>
        <app-overview-bar-item label="自主发布量" tip="客户自行发布的文章数量" :value="stats.publishArticleCount"></app-overview-bar-item>
        <app-overview-bar-item label="总发布量" tip="总发布量=智能发布量+自主发布量" :value="stats.aiPublishArticleCount + stats.publishArticleCount"></app-overview-bar-item>
      </app-overview-bar>
    </app-page-box>
    <app-page-box title="文章发布趋势">
      <div class="page-article__chart-filter">
        <el-button-group>
          <el-button :type="days === 0 ? 'primary' : ''" size="mini" @click="handleDateRangeChange(0)">至今</el-button>
          <el-button :type="days === 30 ? 'primary' : ''" size="mini" @click="handleDateRangeChange(30)">最近30天</el-button>
          <el-button :type="days === 183 ? 'primary' : ''" size="mini" @click="handleDateRangeChange(183)">最近半年</el-button>
        </el-button-group>
        <div class="page-article__chart-date-picker">
          <span>自定义</span>
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            size="mini"
            style="width: 245px;"
            :clearable="false"
            :default-time="['00:00:00', '23:59:59']"
            @change="handleDatePickerChange"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
      </div>
      <app-line-chart :chart-data="chartData"></app-line-chart>
    </app-page-box>
    <app-page-box title="文章发布明细">
      <div class="page-article__filter" slot="tools">
        <el-select v-model="articleStatus" @change="handleArticleStatusChange" size="mini" style="width: 120px;" placeholder="发布源">
          <el-option v-for="item in articleStatuses" :label="item.label" :value="item.id" :key="item.id"></el-option>
        </el-select>
        <span>&nbsp;&nbsp;&nbsp;</span>
        <el-input v-model="query" @keyup.enter.native="handleQueryChange" size="mini" style="width: 200px;" placeholder="请输入内容">
          <i class="el-input__icon el-icon-search" slot="suffix" @click="handleQueryChange"></i>
        </el-input>
      </div>
      <el-table size="mini" :data="detail.list">
        <el-table-column label="标题" prop="title"></el-table-column>
        <el-table-column label="发布源" prop="publishOrigin" :formatter="formatPublishOrigin"></el-table-column>
        <el-table-column label="发布时间">
          <template slot-scope="scope">{{ scope.row.publishTime | formatDate('YYYY-MM-DD HH:mm:ss') }}</template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <a class="page-article__link-view" :href="getHref(scope.row.id)" target="_blank">查看</a>
          </template>
        </el-table-column>
      </el-table>
      <template v-if="detail.total > pageSize">
        <el-pagination
          :total="detail.total"
          :page-size="pageSize"
          :current-page="page"
          @current-change="handlePageChange"
          layout="prev, pager, next"
          background
        ></el-pagination>
      </template>
    </app-page-box>
  </div>
</template>

<script>
import AppPageBox from '@/components/AppPageBox'
import AppTextHelp from '@/components/AppTextHelp'
import AppLineChart from '@/components/AppLineChart'
import AppOverviewBar, { AppOverviewBarItem } from '@/components/AppOverviewBar'
import { getDateRange, getTimestamp } from '@/utils'

const { VUE_APP_CLOUD_SITE_SERVER } = process.env

export default {
  name: 'PageArticleInfo',
  components: {
    AppPageBox,
    AppLineChart,
    AppOverviewBar,
    AppOverviewBarItem
  },

  data () {
    return {
      days: 0,
      dateRange: [],
      query: '',
      articleStatus: 0,
      articleStatuses: [
        { id: 0, label: '全部发布源' },
        { id: 5, label: '自主发布' },
        { id: 105, label: '智能发布' }
      ],
      page: 1,
      pageSize: 10
    }
  },

  computed: {
    user () {
      return this.$store.state.account.user
    },
    stats () {
      return this.$store.state.article.stats
    },
    chartData () {
      return this.$store.state.article.chartData
    },
    detail () {
      return this.$store.state.article.detail
    }
  },

  created () {
    this.setDateRange(0) // 设为至今
    this.getStats()
    this.getChartData()
    this.getDetails()
  },

  methods: {
    getStats () {
      this.$store.dispatch('getArticlesStats', {
        params: { userId: this.user.id }
      })
    },

    getChartData () {
      this.$store.dispatch('getArticleChartData', {
        query: {
          uid: this.user.id,
          start_time: getTimestamp(this.dateRange[0], 's'),
          end_time: getTimestamp(this.dateRange[1], 's')
        }
      })
    },

    getDetails () {
      const articleStatus = this.articleStatus

      this.$store.dispatch('getArticleDetails', {
        params: { userId: this.user.id },
        query: {
          query: this.query || null,
          status: articleStatus ? [ articleStatus ] : [ 5, 105 ],
          offset: (this.page - 1) * this.pageSize,
          limit: this.pageSize
        }
      })
    },

    setDateRange (days) {
      let range = null

      if (days) {
        range = getDateRange(days)
      } else {
        range = { startTime: new Date(2018, 0, 1), endTime: new Date() }
      }

      this.dateRange = [ range.startTime.toISOString(), range.endTime.toISOString() ]
      this.days = days
    },

    getHref (id) {
      return `${VUE_APP_CLOUD_SITE_SERVER}/a${id}`
    },

    resetPage () {
      this.page = 1
    },

    handleDateRangeChange (days) {
      this.setDateRange(days)
      this.getChartData()
    },

    handleDatePickerChange () {
      this.days = null
      this.getChartData()
    },

    renderHeader (createElement, { column }) {
      const pair = column.label.split('|')
      const content = createElement(AppTextHelp, {
        props: {
          text: pair[0],
          tip: pair[1] || 'Why?'
        }
      })

      return content
    },

    formatPublishOrigin (row, column, cellValue, index) {
      const statusMap = {
        5: '自主发布',
        105: '智能发布'
      }

      return statusMap[cellValue] || '其他发布'
    },

    handleArticleStatusChange () {
      this.resetPage()
      this.getDetails()
    },

    handleQueryChange () {
      this.resetPage()
      this.getDetails()
    },

    handlePageChange (page) {
      this.page = page
      this.getDetails()
    }
  }
}
</script>

<style lang="scss">
.page-article {
  .el-pagination {
    margin-top: 15px;
    text-align: right;
  }

  &__chart-filter {
    text-align: right;
  }

  &__chart-date-picker {
    display: inline-block;
    margin-left: 30px;
  }

  &__link-view {
    color: $primary-color;
    &:hover {
      color: darken($color: $primary-color, $amount: 10)
    }
  }
}
</style>
